import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "fm_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => (i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i));
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          slug: product.slug,
          image: product.image,
          price: product.price,
          quantity: qty,
        },
      ];
    });
  };

  const updateQty = (product_id, quantity) => {
    setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i)));
  };

  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const gst = Math.round(subtotal * 0.18);
  const shipping = subtotal > 50000 || subtotal === 0 ? 0 : 750;
  const total = subtotal + gst + shipping;

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, gst, shipping, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
